(() => {
  function init(root) {
    if(root.dataset.initialized) return;
    root.dataset.initialized='true';
    const track=root.querySelector('[data-vr-game-track]');
    const slides=[...track.children];
    const dots=[...root.querySelectorAll('[data-vr-game-dot]')];
    const reduced=window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    const update=()=>{
      const step=slides[1].offsetLeft-slides[0].offsetLeft;
      const max=Math.max(0,Math.round((track.scrollWidth-track.clientWidth)/step));
      const active=Math.min(max,Math.round(track.scrollLeft/step));
      dots.forEach((dot,i)=>{dot.hidden=i>max;dot.setAttribute('aria-current',String(i===active));});
    };
    dots.forEach((dot,i)=>dot.addEventListener('click',()=>{
      track.scrollTo({left:slides[i].offsetLeft-slides[0].offsetLeft,behavior:reduced?'instant':'smooth'});
    }));
    track.addEventListener('scroll',update,{passive:true});
    new ResizeObserver(update).observe(track);
    const observer=new IntersectionObserver(entries=>entries.forEach(entry=>{
      const video=entry.target;
      if(entry.isIntersecting){
        const source=video.querySelector('[data-vr-src]');
        if(source){source.src=source.dataset.vrSrc;source.removeAttribute('data-vr-src');video.load();}
        if(!reduced)video.play().catch(()=>{});
      }else video.pause();
    }),{threshold:0.2});
    root.querySelectorAll('video').forEach(video=>{if(reduced)video.autoplay=false;observer.observe(video);});
    update();
  }
  document.querySelectorAll('[data-vr-game-content]').forEach(init);
  document.addEventListener('shopify:section:load',event=>event.target.querySelectorAll('[data-vr-game-content]').forEach(init));
})();
